import { Link } from "react-router";
import {
  EDITION_BT_LINK,
  EDITION_BTI_LINK,
} from "@features/banner/Edition/utils/constants";
import { getRedirectEditionUrl } from "@features/banner/Edition/utils/helpers";
import { cn } from "@util/helpers";
import Cookies from "js-cookie";
import { useFeatureFlagEnabled } from "posthog-js/react";

type EditionProps = {
  /** This is the classname of the component. */
  className?: string;
  /** Flag to show/hide label. */
  showLabel?: boolean;
};

/** This is the edition switcher component. */
const Edition = ({
  className,
  showLabel = false,
}: EditionProps): React.ReactElement => {
  const isGeoSg = Cookies.get("sph_user_country") === "SG";
  const isOverwritten = useFeatureFlagEnabled(
    "feature_overwrite_condition_edition"
  );

  const handleSG = () => {
    if (typeof window === "undefined") return;

    Cookies.set("preferred_region", "SG");
  };

  const handleNONSG = () => {
    if (typeof window === "undefined") return;

    Cookies.set("preferred_region", "NONSG");
  };

  if (isGeoSg && !isOverwritten) return <></>;

  const editionBTLink = getRedirectEditionUrl().bt || EDITION_BT_LINK;
  const editionBTILink = getRedirectEditionUrl().bti || EDITION_BTI_LINK;

  return (
    <div
      data-testid="edition-component"
      className={cn(
        "w-full font-poppins text-4xs font-medium tracking-tightest text-gray-550",
        className
      )}
    >
      {showLabel ? (
        <p className="mb-0 text-xs font-semibold uppercase text-gray-350">
          CHOOSE EDITION
        </p>
      ) : null}

      <div
        className={cn("flex flex-row items-center justify-center gap-2", {
          "mt-2 justify-start gap-1 rounded-[4px] bg-gray-150 p-1": showLabel,
        })}
      >
        <Link
          to={editionBTLink}
          className={cn(
            "flex items-center justify-center font-semibold text-gray-850 hover:underline",
            {
              "flex-1 rounded-[4px] bg-white py-3 text-center text-sm hover:no-underline lg:py-2 lg:leading-1.6":
                showLabel,
            }
          )}
          onClick={handleSG}
        >
          Singapore
        </Link>

        <Link
          to={editionBTILink}
          className={cn(
            "flex items-center justify-center border-l border-gray-175 pl-2 hover:underline",
            {
              "flex-1 rounded-[4px] border-none py-3 pl-0 text-center text-sm text-gray-515 hover:bg-white hover:no-underline lg:py-2 lg:leading-1.6":
                showLabel,
            }
          )}
          onClick={handleNONSG}
        >
          International
        </Link>
      </div>
    </div>
  );
};

export default Edition;
